import { PAGES_MAP, useAuctionPagesLink } from './useAuctionPagesLink'

export function useGetTypeOfPrevPage() {
  const { options } = useRouter()
  const { getLink } = useAuctionPagesLink()

  /**
   * Check if the previous page is a barometer/details/car list page
   */
  const getTypeOfPrevPage = () => {
    const lastPage = String(options.history.state.back ?? '')

    if (!lastPage?.length)
      return 'none'

    const lastPageWithoutParams = String(lastPage).split('?')[0]
    const [historyLang, ...historySlugs] = lastPageWithoutParams
      .split('/')
      .filter(el => el.length)

    return Object.keys(PAGES_MAP).findIndex(
      (pageType) => {
        return historySlugs.filter((slug) => {
          return (
            getLink({
              page: pageType as keyof typeof PAGES_MAP,
              slug,
              lang: historyLang,
            }) === lastPageWithoutParams
          )
        }).length
      },
    ) >= 0
      ? 'auction'
      : 'cms'
  }

  return { getTypeOfPrevPage }
}
